import React from "react";

import { Grid } from "@mui/material";

import { Strong, Text } from "../components";
import useStyles from "../styles";

const MARGIN_SIZE = "16px";

export const PrivacyPolicyPageCN = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Grid item>
        <Text>
          Shipeezi
          有法律义务遵守影响其业务运营的所有适用法律，每位员工都必须在数据隐私、知识产权和治理等领域发挥自己的作用，满足这些要求。
        </Text>
      </Grid>

      <Grid item marginY={MARGIN_SIZE}>
        <Strong>我们的隐私政策最后更新于 2022 年。</Strong>
        <br />
        <br />
        <Text>
          在
          Shipeezi，我们非常重视隐私。我们制定了本隐私政策，以确保我们以最清晰的方式与客户沟通我们收集、使用、存储和披露个人信息的方式。我们鼓励您仔细阅读本隐私政策。它将帮助客户就与我们共享个人信息做出明智的决定。
        </Text>
        <br />
        <Text>在本隐私政策中，提及：</Text>
        <br />
        <br />
        <Text>{"a)"} “我们”、“我们”和“我们的”是指 Shipeezi Pty Ltd ACN 633 689 764；</Text>
        <br />
        <Text>
          {"b)"}{" "}
          “我”、“您”、“您的”和“客户”是指使用Shipeezi服务和产品（包括Shipeezi网站）或以其他方式向我们提供个人信息的用户。
        </Text>
        <br />
        <br />
        <Text>
          本《隐私政策》中未定义的术语与诗派子网站使用条款中的含义相同。访问诗派子网站和使用服务，即表示您同意我们根据本隐私政策收集、持有、使用和披露您的个人信息。
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>什么是个人信息？</Strong>
        <br />
        <Text>
          Shipeezi 提供服务和产品，包括提供 Shipeezi
          网站（“服务”或“服务”），这可能导致我们收集您的个人信息。
          提供服务可能涉及收集、使用、披露和/或存储有关公司或个人的数据。该数据可能包括个人信息。“个人信息”是关于已识别个人或可以从信息或意见中合理识别的个人的任何信息或意见。信息或意见可能是个人信息，无论其是否真实。
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>我们收集和持有哪些个人信息？</Strong>
        <br />
        <Text>
          当您出现以下情况时，Shipeezi 可能会直接向您收集个人信息：
          <br />
          <br />
          <ul className={classes.tag}>
            <li>在 Shipeezi 网站上创建帐户或注册使用服务；</li>
            <li>使用服务；</li>
            <li>联系施培子支持团队；或者</li>
            <li>访问施培子网站。</li>
          </ul>
        </Text>
        <Text>
          客户始终可以选择不向食贝子提供个人信息，但这可能意味着我们无法向他们提供全部或部分服务。
          <br />
          我们从您那里收集的信息可能包括您的身份和联系方式、您的购买历史、您对服务的使用、您使用服务的商业条款以及您提出的查询或投诉的详细信息。
        </Text>
        <br />
        <br />
        <Text>
          我们可能会收集有关您如何访问、使用网站以及与网站互动的信息。我们通过使用一系列工具（例如
          Google Analytics）来做到这一点。Microsoft Clarity 和 Hubspot。 这些信息可能包括：
          <br />
          <br />
          <ul className={classes.tag}>
            <li>您访问网站的位置和访问过的页面；和</li>
            <li>
              技术数据，可能包括 IP
              地址、您用来访问网站的设备类型、设备属性、浏览器类型、语言和操作系统。
            </li>
          </ul>
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>Shipeezi 使用 cookies</Strong>
        <br />
        <Text>
          在提供服务时，Shipeezi 使用“cookies”。Cookie
          是存储在浏览器计算机上用于保存记录的小文本文件。cookie
          不识别浏览器的个人身份或包含有关浏览器的任何其他信息，但它确实识别他们的计算机。
        </Text>
        <br />
        <br />
        <Text>
          我们和我们的一些附属公司和第三方服务提供商可能会结合使用“持久性
          cookie”（长时间保留在浏览器硬盘上的 cookie）和“会话 ID cookie”（关闭浏览器时过期的
          cookie）浏览器）在 Shipeezi
          网站上跟踪整体网站使用情况，并跟踪和报告您对广告印象和广告服务的使用和互动。
        </Text>
        <br />
        <br />
        <Text>
          浏览器可以将其浏览器设置为在收到 cookie
          时通知自己，以便他们有机会在每个实例中接受或拒绝它。但是，浏览器应注意，拒绝 cookie
          可能会对服务的功能和可用性产生负面影响。
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>我们为何收集、持有和使用您的个人信息？</Strong>
        <br />
        <Text>Shipeezi 出于有限的目的收集、持有和使用您的个人信息。 </Text>
        <br />
        <br />
        <Text>
          Shipeezi 收集个人信息以便我们能够为您提供服务以及您可能要求的任何相关服务。为此，Shipeezi
          可能会使用我们从客户那里收集的个人信息来提供服务以及与服务相关的目的，包括：
        </Text>
        <br />
        <br />
        <Text>
          <ul className={classes.tag}>
            <li>验证身份；</li>
            <li>管理服务；</li>
            <li>通知客户新服务或现有服务的变更；</li>
            <li>开展与服务相关的营销或培训；</li>
            <li>协助解决技术支持问题或与服务相关的其他问题；</li>
            <li>遵守适用司法管辖区的法律法规；</li>
            <li>与客户就服务和 Shipeezi 一般情况进行沟通；和</li>
            <li>与上述任何一项合理相关的任何其他目的。</li>
          </ul>
        </Text>
        <Text>
          {" "}
          使用服务，即表示您同意以这种方式收集、持有和使用您的个人信息。对于本隐私政策中未明确规定的任何使用，Shipeezi
          将征求您的同意。
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>我们如何收集您的个人信息？</Strong>
        <br />
        <Text>
          除了上述收集方法外，我们还可能收集数据：
          <br />
          Shipeezi 可能会从客户那里收到有关其他人的个人信息。
        </Text>
        <br />
        <br />
        <Text>
          通过客户使用服务，Shipeezi
          还可能从客户那里收集有关其他人（例如客户或服务提供商）的信息。如果客户向 Shipeezi
          提供有关其他人的个人信息，他们必须确保他们有权向 Shipeezi 披露该信息，并且在 Shipeezi
          不采取适用数据保护或隐私法要求的任何进一步措施的情况下，Shipeezi
          可以收集、使用和披露此类信息用于本隐私政策中所述目的的信息。
        </Text>
        <br />
        <br />
        <Text>
          这意味着客户必须采取合理措施确保相关个人了解和/或同意本隐私政策中详述的各种事项，包括收集其个人信息的事实、收集该信息的目的、该信息的预期接收者、个人获取该信息的权利、Shipeezi
          的身份以及联系 Shipeezi 的方式。
        </Text>
        <br />
        <br />
        <Text>
          当 Shipeezi 提出要求时，客户还必须协助 Shipeezi
          处理个人提出的访问或更新客户从他们那里收集并披露给 Shipeezi 的个人信息的任何请求。
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>Shipeezi 可以汇总客户的非个人身份数据</Strong>
        <br />
        <Text>
          通过使用服务，客户同意 Shipeezi 可以访问、汇总和使用 Shipeezi
          从客户那里收集的非个人身份数据，并且可以手动去除个人信息以创建非个人身份信息数据集。此数据绝不会识别客户或任何其他个人。
        </Text>
        <br />
        <br />
        <Text>Shipeezi 可能会使用这些汇总的非个人身份数据来：</Text>
        <br />
        <br />
        <Text>
          <ul className={classes.tag}>
            <li>帮助我们更好地了解我们的客户如何使用服务；</li>
            <li>向我们的客户提供有关服务的用途和好处的更多信息；</li>
            <li>
              提高业务生产力，包括通过从聚合数据中创建有用的业务洞察力，并允许客户根据该聚合数据对他们的业务绩效进行基准测试；以及
              以其他方式改进服务。
            </li>
          </ul>
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>我们如何存储和持有个人信息？</Strong>
        <br />
        <Text>Shipeezi 将您的个人信息保存在位于澳大利亚的服务器上。</Text>
        <br />
        <br />
        <Text>
          所有数据，包括客户输入服务的或根据他们的指示自动导入的个人和非个人信息，都将作为通过互联网传输的功能传输到
          Shipeezi
          的服务器。通过使用该服务，客户同意按照本隐私政策的规定将他们的个人信息传输到我们的服务器。
        </Text>
        <br />
        <br />
        <Text>
          目前我们的服务器位于云端，主要由 AWS
          托管。作为服务的一部分，客户的个人信息将通过这些服务器传送并存储在这些服务器上。如果我们服务器的位置将来发生变化，我们将更新本隐私政策。客户应定期查看我们的隐私政策以随时了解任何更新。
        </Text>
        <br />
        <br />
        <Text>
          通过向 Shipeezi 提供个人信息，客户同意 Shipeezi
          将您的个人信息存储在澳大利亚托管的服务器上。虽然个人信息将存储在位于澳大利亚的服务器上，但它始终处于
          Shipeezi 的有效控制之下。服务器主机的作用仅限于为 Shipeezi
          提供托管和存储服务，我们已采取措施确保我们的服务器主机无法访问客户的个人信息，并对其使用必要的保护级别。
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>Shipeezi 采取措施保护个人信息</Strong>
        <br />
        <Text>
          Shipeezi
          致力于保护个人信息的安全，我们采取一切合理的预防措施来保护它免遭未经授权的访问、修改或披露。这些预防措施包括：
        </Text>
        <br />
        <br />
        <Text>
          <ul className={classes.tag}>
            <li>
              个人信息存储在具有领先证书颁发机构 Trustwave 颁发的 SSL
              证书的安全服务器上，并且您与服务之间传输的所有数据均已加密；
            </li>
            <li>所有员工必须遵守内部信息安全政策并确保信息安全；和</li>
            <li>根据我们自己的政策和行业最佳实践定期监控和审查我们的实践。</li>
          </ul>
        </Text>
        <Text>
          然而，互联网本身并不是一个安全的环境，我们无法绝对保证您的信息始终安全。通过 Internet
          传输个人信息的风险由客户自行承担，他们只能在安全的环境中将个人信息输入或指示将个人信息输入服务。
        </Text>
        <br />
        <br />
        <Text>
          在发现或被告知存在安全漏洞时，我们将在第一个合理的机会通知任何未经授权的人或以任何未经授权的方式丢失、被盗、访问、使用、披露、复制、修改或处置客户的个人信息。
        </Text>
        <br />
        <br />
        <Text>
          如果我们的客户是帐户持有人，则他们有责任确保他们的服务密码安全。如果他们发现密码被滥用，应尽快通知我们，并立即在服务中或通过“忘记密码”程序更改密码。
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>我们向谁披露您的个人信息，为什么？</Strong>
        <br />
        <Text>世培子仅在有限的情况下披露个人信息。</Text>
        <br />
        <br />
        <Text>
          世培子可能会出于商业目的向第三方提供客户的个人信息，包括他们使用服务的商业条款，如果客户已被世培子的商业合作伙伴推荐给世培子。客户明确同意出于此类目的向第三方披露个人信息。
        </Text>
        <br />
        <br />
        <Text>
          只有在必要且适当的情况下，Shipeezi
          才会将客户提供给我们的个人信息披露给其他实体，以促进根据本隐私政策收集个人信息的目的，包括提供服务。客户明确同意向世培子成员及其相关法人团体披露个人信息。
        </Text>
        <br />
        <br />
        <Text>
          Shipeezi 可能会向协助 Shipeezi
          提供服务的第三方服务提供商或其他第三方出于信用报告和交易处理服务等相关目的提供客户的个人信息，并且客户明确同意为此类目的转移个人信息，每个案例在全球范围内。
        </Text>
        <br />
        <br />
        <Text>
          Shipeezi 不会以其他方式向第三方披露任何个人信息，除非客户明确表示同意，或者除非 Shipeezi
          根据澳大利亚隐私法另行允许。但是，客户应注意，如果法律要求披露个人信息，Shipeezi
          可能会被要求在未经同意的情况下披露个人信息，以遵守任何法院命令、传票或包括税务机关在内的其他法律程序或调查。在可能和适当的情况下，如果法律要求我们披露任何个人信息，我们将通知客户。
        </Text>
        <br />
        <br />
        <Text>
          托管我们服务器的第三方不控制也不允许访问或使用客户的个人信息，但存储信息的有限目的除外。这意味着，出于澳大利亚隐私立法和服务澳大利亚用户的目的，Shipeezi
          目前不会向位于海外的第三方“披露”个人信息。
        </Text>
        <br />
        <br />
        <Text>
          尽管有上述条款，虽然世培子将采取一切合理措施保护客户的个人信息，但应该承认，任何海外个人信息接收者可能不受澳大利亚隐私法的约束，并且客户同意世培子披露其个人信息根据本隐私政策向海外收件人发送信息意味着
          Shipeezi 没有义务采取合理措施确保海外收件人不违反澳大利亚隐私法。
        </Text>
        <br />
        <br />
        <Text>
          如果全部或部分业务的所有权或控制权发生变化，我们可能会将您的个人信息转让给新的所有者。
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>我们是否将您的个人信息用于营销？</Strong>
        <br />
        <Text>
          我们将使用您的个人信息为您提供我们认为您可能感兴趣的产品和服务，但如果您告诉我们不要这样做，我们将不会这样做。
        </Text>
        <br />
        <br />
        <Text>
          如果您收到我们的电子营销通讯，您可以按照通讯中提供的退出说明选择退出接收进一步的营销通讯。
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>访问和更正您的个人信息</Strong>
        <br />
        <Text>
          客户有责任确保提供给我们的个人信息是准确、完整和最新的。客户可以通过书面形式提出请求并将其发送至
          support@shipeezi.com
          来请求访问我们持有的关于他们自己的信息，或要求我们更新、更正或删除我们持有的关于他们的任何个人信息。收到这些请求后，我们可能会向客户索取信息，以确认他们是个人信息的相关人员，然后再处理他们的请求。
        </Text>
        <br />
        <br />
        <Text>
          Shipeezi
          将在合理可行的情况下尽快处理该请求，前提是我们没有因法律原因而无法这样做。如果我们无法满足他们的要求，我们会告知他们原因。例如，如果某项请求会对其他人的隐私或事务产生不合理的影响，或者如果我们处理该请求不合理且不可行，我们可能有必要拒绝该请求。
        </Text>
        <br />
        <br />
        <Text>
          客户还可以删除其客户、客户或服务提供商的信息。我们的服务和相关文档提供了从服务中删除关于他们或他们的客户、客户或服务提供商的某些信息的能力。例如，他们可以使用与该内容关联的关键字搜索和编辑工具删除包含有关他们的信息的内容，并且他们可以删除其个人资料设置中的某些个人资料信息。但请注意，我们可能需要保留某些信息以用于记录保存目的、完成交易或遵守我们的法律义务。
        </Text>
        <br />
        <br />
        <Text>
          我们只会在为客户提供服务所需的时间内保留个人信息。但是，我们也可能需要在特定时间段内保留一些个人信息，例如，根据与公司、洗钱和财务报告立法相关的某些法律。
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>您在欧盟 GDPR 下的权利</Strong>
        <br />
        <Text>根据欧盟 (EU) 通用数据保护条例 (GDPR)，作为数据主体，您有权：</Text>
        <br />
        <br />
        <Text>
          <ul className={classes.tag}>
            <li>访问您的数据；;</li>
            <li>在不准确的地方删除或更正您的数据；</li>
            <li>反对处理您的数据并限制处理；</li>
            <li>撤回对处理您的数据的同意；</li>
            <li>以标准格式提供您的数据，以便可以将其传输到其他地方；和</li>
            <li>不受仅基于自动处理的决定的约束。</li>
          </ul>
        </Text>
        <Text>（数据主体权利）</Text>
        <br />
        <Text>
          我们制定了处理数据主体权利请求的流程。我们的行动和责任将取决于我们是相关个人数据的控制者还是处理者。根据我们作为控制者或处理者的角色，启用数据主体权利的过程可能会有所不同，并且始终受适用法律的约束。
        </Text>
        <br />
        <br />
        <Text>如果您想提出数据主体权利请求，请参阅本隐私政策的联系方式部分。</Text>
        <br />
        <br />
        <Text>客户可以选择退出任何电子邮件通信</Text>
        <br />
        <br />
        <Text>
          食派子通过电子邮件向客户发送账单信息、产品信息、服务更新和服务通知。我们的电子邮件将包含清晰明了的说明，说明客户如何选择从对服务不重要的任何邮件列表中删除。Shipeezi
          将根据他们的要求删除任何人。
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Text>
          服务可能允许客户以电子方式将数据（包括他们的个人信息）传输至第三方应用程序或从第三方应用程序传输数据。Shipeezi
          无法控制这些应用程序的隐私惯例或内容，也不对这些应用程序的内容承担任何责任。客户有责任查看任何此类应用程序的隐私政策，以便他们了解该第三方将如何处理个人信息。
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>联系方式</Strong>
        <br />
        <Text>Shipeezi 有一个隐私投诉程序。</Text>
        <br />
        <br />
        <Text>
          如果任何客户或浏览者希望投诉我们如何处理他们的个人信息，他们可以向我们的隐私官提供他们投诉的全部细节和任何支持文件:
        </Text>
        <br />
        <Text>发送电子邮件至 support@shipeezi.com；或</Text>
        <Text>
          写信给 The Privacy Officer, Shipeezi Pty Ltd, Level 2/11 York Street, Sydney NSW 2000。
        </Text>
        <br />
        <br />
        <Text>我们的隐私官将努力：</Text>
        <br />
        <br />
        <Text>
          <ul className={classes.tag}>
            <li>在 10 个工作日内对查询或投诉作出初步答复；和</li>
            <li>在 30 个工作日或必要的更长期限内调查并尝试解决查询或投诉，并通知他们。</li>
          </ul>
        </Text>
        <Text>
          如果您对我们处理隐私问题的方式仍然不满意，您可以联系独立顾问或联系澳大利亚信息专员办公室
          (OAIC) (www.oaic.gov.au) 以获得替代行动方案的指导这可能是可用的。
        </Text>
      </Grid>

      <Grid item>
        <Strong>本隐私政策的变更</Strong>
        <br />
        <Text>本隐私政策可能会不时更新。</Text>
        <br />
        <br />
        <Text>
          世培子保留随时更改本隐私政策的权利，本隐私政策的任何修订一经发布至世培子网站即生效。Shipeezi
          将尽一切努力通过服务通过电子邮件或通知向您传达任何重大变更。
        </Text>
        <br />
        <br />
        <Text>您继续使用服务将被视为接受任何修订后的隐私政策。</Text>
      </Grid>
    </React.Fragment>
  );
};
